import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';
import PlayIcon from '../components/PlayIcon.js';

const ServicesSection = () => (
    <section id="services" className="h-screen w-screen flex-shrink-0 flex flex-col md:flex-row items-center justify-center p-8 md:p-16 bg-brand-black overflow-hidden">
        <div className="w-full md:w-1/2">
        <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white text-base sm:text-lg md:text-xl leading-relaxed"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}
>
    <p className='text-base sm:text-lg md:text-xl leading-relaxed'   style={{ fontFamily: 'pinar', color: '#FFF' , textAlign: "justify", textAlignLast: "right", direction: "rtl" }}>
  
  یکی از دلایل شکست پروژها ، <a className='text-base sm:text-lg md:text-xl leading-relaxed' style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>برندینگ</a> نبود. بلکه یک چهارچوب منسجم است. اقداماتی مانند <a className='text-base sm:text-lg md:text-xl leading-relaxed' style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>طراحی</a> ، <a className='text-base sm:text-lg md:text-xl leading-relaxed' style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>تبلیغات</a> یا <a className='text-base sm:text-lg md:text-xl leading-relaxed' style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>تولید محتوا</a> اگر بدون مسیر استراتژیک انجام شوند ، تنها خروجیهای پراکنده و کوتاه مدت ایجاد می کند.
  </p>
</AnimatedElement>
        </div>
        <div className="w-full md:w-1/2 mt-12 md:mt-0 md:pl-16 pb-3">
            <div className="relative mb-8">
            <img src=".\assets\img\ax-site-final6.png" alt="Won J. You" className="p-0 m-0  w-full h-full object-cover  object-left hidden md:block w-full h-auto" />
            <div className="mt-1 w-full h-2 rounded-full bg-red-600 shadow-[0_0_12px_#ff0000,0_0_25px_#ff3333,0_4px_8px_rgba(0,0,0,0.5)]"></div>

            </div>
            
        </div>
    </section>
);

export default ServicesSection;
